import React from "react";
import HeaderComponent from "./UI/HeaderComponent";
import style from "../Assets/css/dashboard_component.css";
import FooterComponent from "./UI/FooterComponent";
import Tabs from "./UI/Tabs";
import UKCommunicationRecordAnalyticsComponent from "./UKCommunicationRecordAnalyticsComponent";
import UKCommunicationRecordReportingComponent from "./UKCommunicationRecordReportingComponent";
import UKCommunicationRecordOrdersComponent from "./UKCommunicationRecordOrdersComponent";
import UKCommunicationRecordTransactionsComponent from "./UKCommunicationRecordTransactionsComponent";
import UKCommunicationRecordClientOrderComponent from "./UKCommunicationRecordClientOrderComponent";

const UKCommunicationRecordDashboardComponent = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <HeaderComponent visibility={true} />
    <div style={{ flex: 1 }}>
      <Tabs>
        <div className={style.tab1} label="Analytics">
          <UKCommunicationRecordAnalyticsComponent />
        </div>
        <div className="tab2" label="Reporting">
          <UKCommunicationRecordReportingComponent />
        </div>
        <div className="tab2" label="Orders">
          <UKCommunicationRecordOrdersComponent />
        </div>
        <div className="tab2" label="Transactions">
          <UKCommunicationRecordTransactionsComponent />
        </div>
        <div className="tab2" label="Client Order">
          <UKCommunicationRecordClientOrderComponent />
        </div>
      </Tabs>
    </div>
    <FooterComponent />
  </div>
  );
};

export default UKCommunicationRecordDashboardComponent;
